import React, { useEffect, useRef, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
} from "../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import { UserIcon } from "../../components/Icon";

import {
  assignInvoiceColumnsToClientAction,
  getAllInvoiceColumnsListAction,
  getAllMappedClientColumnListAction,
  getAllOtherInvoicesListAction,
  getInvoiceAllComment,
  getInvoiceHistoryDataAction,
  getOthersInvoiceHistoryDataAction,
  postInvoiceAllComment,
  postLockingEntryAction,
  postLockingEntryBOMAction,
  resetcommentsSuccess,
  resetExpenseInvoicesTotal,
  resetInvoiceGenerationError,
  resetInvoiceGenerationOverDueEmailMessage,
  resetInvoiceGenerationOverDueEmailSuccess,
  resetInvoiceGenerationSuccess,
  resetInvoiceHistoryData,
  resetInvoicingSuccess,
  resetMappedExpensesColumnList,
  resetOtherInvoicesTotal,
  resetOthersHistoryCount,
  resetOthersHistoryData,
  resetRevenueInvoicesTotal,
  resetSingleInvoiceDetails,
  resetSuccess,
  sendOverdueEmailApiAction,
} from "../../redux/invoiceGeneration";
import {
  getAllBusinessAddressAction,
  getSingleCustomerSupplierAction,
  resetSingleCustomerSupplier,
} from "../../redux/clientSettings";
import {
  AddCommentPayloadType,
  AssignInvoiceColumnsToClientPayloadType,
  GetAllMappedClientColumnsPayloadType,
  GetAllOtherInvoicesListPayloadType,
  GetCommentPayloadType,
  InvoiceHistoryPayloadType,
  LockEntryBomPayloadType,
  LockEntryPayloadType,
  SendOverdueEmailPayloadType,
} from "../../commonTypes/invoiceGenerationTypes";
import {
  InvoiceGenerationCategoryType
} from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import AllOtherInvoicesList from "../../components/InvoiceGeneration/OtherEntry/AllOtherInvoicesListTable/AllOtherInvoicesList";
import ExpenseInvoicesList, {
  SendInvoiceEmailData,
} from "../../components/InvoiceGeneration/ExpenseEntry/ExpenseInvoicesList";
import RevenueInvoicesList from "../../components/InvoiceGeneration/RevenueEntry/RevenueInvoicesList";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import InvoiceCommentsModal from "../../components/InvoiceGeneration/InvoiveCommentsModal";
import { toast, Toaster } from "react-hot-toast";
import { AddIconColor, AddIconWhite } from "../../assets/images";
import { GetSingleCustomerSupplierListPayloadType } from "../../commonTypes/clientSettingsTypes";
import { CustomerSupplierListType } from "../../redux/clientSettings/clientSettingTypes";
import SendInvoiceEmailModal from "../../components/InvoiceGeneration/SendInvoiceEmailModal";
import BomInvoicesList from "../../components/InvoiceGeneration/BillOfMaterial/BillOfMaterialList/BomInvoicesList";
import BOMAddModal from "../../components/InvoiceGeneration/BillOfMaterial/BOMAddModal";
import { useParams } from "react-router-dom";
import {
  resetCurrencyExchangeDetails,
  resetMasterSuccess,
} from "../../redux/masterData";
import WeeklyApprovedUsersInvoiceEntriesCountCard from "../../components/ThinksToDo/JobClosureModule/WeeklyApprovedUsersInvoiceEntriesCountCard";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  overDueEmailSuccess: number | null;
  overDueEmailMessage: string | null;
  error: string | null;
  statusCode: number | null;
  invoiceGeneration: any | null;
  dispatchResetSession: () => void;
  dispatchResetInvoicingError: () => void;
  dispatchResetInvoicingSuccess: () => void;
  dispatchResetMessageAndSuccess: () => void;
  userData: any;
  companyName: string;
  currencySign: string | undefined;
  othersHistoryData: any;
  othersHistoryCount: number;
  mappedExpensesColumnsList: InvoiceGenerationCategoryType;
  mappedRevenueColumnsList: InvoiceGenerationCategoryType;
  mappedOthersColumnList: InvoiceGenerationCategoryType;
  dispatchGetAllColumnsAction: (token: string) => void;
  dispatchAssignColumnsToClientAction: (
    data: AssignInvoiceColumnsToClientPayloadType
  ) => void;
  dispatchGetClientColumnListAction: (
    data: GetAllMappedClientColumnsPayloadType
  ) => void;
  dispatchResetInvoiceGenerationSuccess: () => void;
  dispatchResetInvoiceGenerationError: () => void;
  dispatchResetMappedExpensesColumnsListAction: () => void;
  dispatchGetAllBusinessAddressAction: (data: any) => void;
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) => void;
  allComments: any;
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) => void;
  dispatchPostLockEntryAction: (data: LockEntryPayloadType) => void;
  dispatchResetCommentsSuccess: () => void;
  commentsSuccess: null | number;
  expensesInvoicesTotal: string | number;
  revenueInvoicesTotal: string | number;
  otherInvoicesTotal: string | number;
  customerSingleInvoiceData: any;
  dispatchResetOtherInvoicesTotal: () => void;
  dispatchResetRevenueInvoicesTotal: () => void;
  dispatchResetExpenseInvoicesTotal: () => void;
  message: null | string;
  dispatchResetSuccess: () => void;
  invoiceHistoryData: any;
  isRevenueHistory: boolean;
  invoiceHistoryCount: number;
  dispatchGetInvoiceHistoryAction: (data: InvoiceHistoryPayloadType) => void;
  dispatchGetOthersInvoiceHistoryAction: (
    data: InvoiceHistoryPayloadType
  ) => void;
  dispatchResetOtherHistoryData: () => void;
  dispatchResetOtherHistoryCount: () => void;
  dispatchResetInvoiceHistoryAction: () => void;
  dispatchResetSingleCustomerSupplier: () => void;
  dispatchResetInvoiceGenerationOverDueEmailSuccess: () => void;
  singleCustomerSupplier: CustomerSupplierListType;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchSendOverdueEmailApiAction: (
    data: SendOverdueEmailPayloadType
  ) => void;
  dispatchResetInvoiceGenerationOverDueEmailMessage: () => void;
  dispatchResetCurrencyExchangeDetails: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetSingleInvoiceDetails: () => void;
  dispatchPostLockEntryBomAction:(data:LockEntryBomPayloadType)=>void;
};

interface TabsType {
  name?: string | undefined;
  label?: string | undefined;
  display: boolean | undefined;
}

let tabs: TabsType[] | undefined = [
  {
    name: "Expense Invoices",
    label: "expenses",
    display: false,
  },
  {
    name: "Sales Invoices",
    label: "revenues",
    display: false,
  },
  {
    name: "Other Entries",
    label: "others",
    display: false,
  },
  {
    name: "Manufacturing Journal",
    label: "manufacturing",
    display: false,
  },
];

const InvoiceGenerationList = ({
  history,
  token,
  fetching,
  userData,
  success,
  error,
  statusCode,
  currencySign,
  companyName,
  customerSingleInvoiceData,
  invoiceHistoryData,
  dispatchResetSession,
  dispatchResetInvoicingError,
  dispatchGetClientColumnListAction,
  dispatchGetAllColumnsAction,
  dispatchPostLockEntryAction,
  dispatchResetInvoiceGenerationError,
  dispatchResetInvoiceGenerationSuccess,
  dispatchResetMappedExpensesColumnsListAction,
  mappedExpensesColumnsList,
  mappedOthersColumnList,
  mappedRevenueColumnsList,
  invoiceGeneration,
  dispatchGetAllBusinessAddressAction,
  dispatchGetAllInvoiceCommentsAction,
  allComments,
  dispatchPostAllInvoiceCommentsAction,
  dispatchResetCommentsSuccess,
  dispatchResetMessageAndSuccess,
  commentsSuccess,
  expensesInvoicesTotal,
  revenueInvoicesTotal,
  otherInvoicesTotal,
  dispatchResetOtherInvoicesTotal,
  dispatchResetRevenueInvoicesTotal,
  dispatchResetExpenseInvoicesTotal,
  message,
  dispatchResetSuccess,
  dispatchResetSingleCustomerSupplier,
  singleCustomerSupplier,
  dispatchGetSingleCustomerSupplierAction,
  dispatchGetOthersInvoiceHistoryAction,
  dispatchSendOverdueEmailApiAction,
  dispatchResetInvoiceGenerationOverDueEmailSuccess,
  overDueEmailSuccess,
  overDueEmailMessage,
  invoiceHistoryCount,
  othersHistoryData,
  othersHistoryCount,
  dispatchResetOtherHistoryData,
  dispatchResetOtherHistoryCount,
  dispatchResetInvoiceGenerationOverDueEmailMessage,
  dispatchResetInvoiceHistoryAction,
  dispatchGetInvoiceHistoryAction,
  dispatchResetCurrencyExchangeDetails,
  dispatchResetMasterSuccess,
  dispatchResetSingleInvoiceDetails,
  dispatchPostLockEntryBomAction
}: AppProps) => {
  const { id }: any = useParams();
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : id?.includes("#")
      ? +id?.split("#")[0]
      : id;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  let hash = history?.location?.hash?.replace(/[^\w\s]/gi, "");

  const finalTabFromPath = history?.location?.pathname.split("#")[1];

  const activeUrlTab = hash ? hash : finalTabFromPath;
  const [activeTab, setActiveTab] = useState(activeUrlTab);

  const [showInvoiceCommentsModal, setShowInvoiceCommentsModal] =
    useState<boolean>(false);
  const [invoiceData, setInvoiceData] = useState<any>(null);
  const [showSendInvoiceEmailModal, setShowSendInvoiceEmailModal] =
    useState<boolean>(false);
  const [sendInvoiceEmailInput, setSendInvoiceEmailInput] =
    useState<string>("");
  const [invoiceId, setInvoiceId] = useState<number | null>(null);
  const [fileAttachment, setFileAttachment] = useState<number | null>(null);
  const [isInvoiceHistory, setIsInvoiceHistory] = useState<boolean>(false);
  //========== User Management ==========//
  const [isAddExpensePresent, setIsAddExpensePresent] = useMenuCheck();
  const [isAddSalesPresent, setIsAddSalesPresent] = useMenuCheck();
  const [isAddOthersPresent, setIsAddOthersPresent] = useMenuCheck();
  const [isEditOthersPresent, setIsEditOthersPresent] = useMenuCheck();
  const [isEditSalesPresent, setIsEditSalesPresent] = useMenuCheck();
  const [isDownloadSalesPresent, setIsDownloadSalesPresent] = useMenuCheck();
  const [isEditExpensePresent, setIsEditExpensePresent] = useMenuCheck();
  const [isExpenseEntryPresent, setIsExpenseEntryPresent] = useMenuCheck();
  const [isManufacturingPresent, setIsManufacturingPresent] = useMenuCheck();
  const [invoiceAuditData, setInvoiceAuditData] = useState<any>([]);
  const [invoiceOthersData, setInvoiceOthersData] = useState<any>([]);
  const [invoiceHistoryOffset, setInvoiceHistoryOffset] = useState(0);
  const [invoiceHistoryLimit, setInvoiceHistoryLimit] = useState(6);
  const invoiceHistoryId = useRef<null | number>(null);
  const [isAddManufacturingPresent, setIsAddManufacturingPresent] =
    useMenuCheck();
  const [isEditManufacturingPresent, setIsEditManufacturingPresent] =
    useMenuCheck();
  const [isSalesEntryPresent, setIsSalesEntryPresent] = useMenuCheck();
  const [isOthersEntriesPresent, setIsOthersEntriesPresent] = useMenuCheck();
  const [isDownloadExpenseReportPresent, setIsDownloadExpenseReportPresent] =
    useMenuCheck();
  const [isDownloadSalesReportPresent, setIsDownloadSalesReportPresent] =
    useMenuCheck();
  const [isDownloadOtherReportPresent, setIsDownloadOtherReportPresent] =
    useMenuCheck();
  const [isBulkUploadOtherPresent, setIsBulkUploadOtherPresent] =
    useMenuCheck();
  const [isBulkUploadExpensePresent, setIsBulkUploadExpensePresent] =
    useMenuCheck();
  const [isBulkUploadSalesPresent, setIsBulkUploadSalesPresent] =
    useMenuCheck();
  const [isExpenseListCommentPresent, setIsExpenseListCommentPresent] =
    useMenuCheck();
  const [isRevenueListCommentPresent, setIsRevenueListCommentPresent] =
    useMenuCheck();
  const [isViewExpensesInvoicePresent, setIsViewExpensesInvoicePresent] =
    useMenuCheck();
  const [isViewSalesInvoicePresent, setIsViewSalesInvoicePresent] =
    useMenuCheck();
  const [isViewOthersInvoicePresent, setIsViewOthersInvoicePresent] =
    useMenuCheck();
  const [isOthersListCommentPresent, setIsOthersListCommentPresent] =
    useMenuCheck();
  const [isRevenueHistory, setIsRevenueHistory] = useMenuCheck();
  const [isExpenseHistory, setIsExpenseHistory] = useMenuCheck();
  const [isOthersHistory, setIsOthersHistory] = useMenuCheck();
  const [isEinvoice, setIsEinvoice] = useMenuCheck();
  const [pdfInvoiceId, setPdfInvoiceId] = useState<number | null>(null);
  const [
    isUsersWeeklyApprovedInvoiceTotalCount,
    setIsUsersWeeklyApprovedInvoiceTotalCount,
  ] = useMenuCheck("weeklyApproved");
  const [isExpenseInvoiceDownloadPresent, setIsExpenseInvoiceDownloadPresent] = useMenuCheck();
  //====================//

  useEffect(() => {
    dispatchResetMessageAndSuccess();
    dispatchResetSingleInvoiceDetails();
    dispatchResetMasterSuccess();
    dispatchResetCurrencyExchangeDetails();
    dispatchResetSingleCustomerSupplier();
    dispatchResetExpenseInvoicesTotal();
    dispatchResetRevenueInvoicesTotal();
    dispatchResetOtherInvoicesTotal();
    dispatchResetInvoiceGenerationError();
    dispatchResetInvoiceGenerationSuccess();
    dispatchResetInvoiceHistoryAction();
    dispatchResetMappedExpensesColumnsListAction();
    setIsAddExpensePresent("Add Expense", "menu");
    setIsAddSalesPresent("Add Sales", "menu");
    setIsAddOthersPresent("Add Others", "menu");
    setIsEditOthersPresent("Edit Others Invoicing Advanced", "menu");
    setIsEditSalesPresent("Edit Sales Invoicing Advanced", "menu");
    setIsEditExpensePresent("Edit Expense Invoicing Advanced", "menu");
    setIsDownloadSalesPresent("Download Sales Invoicing Advanced", "menu");
    setIsOthersEntriesPresent("Other Entries", "menu");
    setIsSalesEntryPresent("Sales Invoices", "menu");
    setIsExpenseEntryPresent("Expense Invoices", "menu");
    setIsDownloadExpenseReportPresent("Download Expense IA", "menu");
    setIsDownloadSalesReportPresent("Download Revenues IA", "menu");
    setIsDownloadOtherReportPresent("Download Others IA", "menu");
    setIsBulkUploadOtherPresent("Bulk Upload Other Entries", "menu");
    setIsBulkUploadExpensePresent("Bulk Upload Expense Entries", "menu");
    setIsBulkUploadSalesPresent("Bulk Upload Sales Entries", "menu");
    setIsExpenseListCommentPresent("List Expenses Invoice Comment", "menu");
    setIsRevenueListCommentPresent("List Revenues Invoice Comment", "menu");
    setIsViewExpensesInvoicePresent("View Expenses Invoicing Advanced", "menu");
    setIsViewSalesInvoicePresent("View Revenues Invoicing Advanced", "menu");
    setIsViewOthersInvoicePresent("View Other Invoicing Advanced", "menu");
    setIsViewSalesInvoicePresent("View Revenues Invoicing Advanced", "menu");
    setIsOthersListCommentPresent("List Others Invoice Comments", "menu");
    setIsManufacturingPresent("Manufacturing List", "menu");
    setIsAddManufacturingPresent("Add Manufacturing", "menu");
    setIsEditManufacturingPresent("Edit Manufacturing", "menu");
    setIsEinvoice("E-Invoice", "menu");
    setIsExpenseHistory("Expense History", "menu");
    setIsRevenueHistory("Revenue History", "menu");
    setIsOthersHistory("Others History", "menu");
    setIsUsersWeeklyApprovedInvoiceTotalCount(
      "Weekly Approved Users Invoice Entries Count",
      "menu"
    );
    setIsExpenseInvoiceDownloadPresent("Download Expense Invoicing Advanced", "menu");
    dispatchResetInvoiceGenerationOverDueEmailSuccess();
    dispatchResetInvoiceGenerationOverDueEmailMessage();
    if (token) {
      let finalData = {
        token,
        client_code,
      };

      dispatchGetClientColumnListAction(finalData);
      dispatchGetAllBusinessAddressAction(finalData);
    }
 // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeUrlTab === activeTab) {
    } else {
      setActiveTab(activeUrlTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeUrlTab]);

  useEffect(() => {
    if (isExpenseEntryPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "expenses") {
          return (e.display = true);
        }
      });
    }
    if (isSalesEntryPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "revenues") {
          return (e.display = true);
        }
      });
    }
    if (isOthersEntriesPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "others") {
          return (e.display = true);
        }
      });
    }
    if (isManufacturingPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "manufacturing") {
          return (e.display = true);
        }
      });
    }
    if (isExpenseEntryPresent === false) {
      tabs?.forEach((e: any) => {
        if (e.label === "expenses") {
          return (e.display = false);
        }
      });
    }
    if (isSalesEntryPresent === false) {
      tabs?.forEach((e: any) => {
        if (e.label === "revenues") {
          return (e.display = false);
        }
      });
    }
    if (isOthersEntriesPresent === false) {
      tabs?.forEach((e: any) => {
        if (e.label === "others") {
          return (e.display = false);
        }
      });
    }
    if (isManufacturingPresent === false) {
      tabs?.forEach((e: any) => {
        if (e.label === "manufacturing") {
          return (e.display = false);
        }
      });
    }
  }, [
    isExpenseEntryPresent,
    isSalesEntryPresent,
    isOthersEntriesPresent,
    isManufacturingPresent,
  ]);

  useEffect(() => {
    if (singleCustomerSupplier?.email) {
      setSendInvoiceEmailInput(singleCustomerSupplier?.email);
    } else {
      setSendInvoiceEmailInput("");
    }
  }, [singleCustomerSupplier]);

  useEffect(() => {
    if (activeTab === "others") {
      if (
        invoiceHistoryId.current &&
        invoiceHistoryOffset > 0 &&
        invoiceHistoryOffset < othersHistoryCount
      ) {
        let finalData = {
          clientCode: client_code,
          invoiceId: invoiceHistoryId.current,
          token,
          offset: invoiceHistoryOffset,
          limit: invoiceHistoryLimit,
        };
        dispatchGetOthersInvoiceHistoryAction(finalData);
      }
    } else {
      if (
        invoiceHistoryId.current &&
        invoiceHistoryOffset > 0 &&
        invoiceHistoryOffset < invoiceHistoryCount
      ) {
        let finalData = {
          invoiceType:
            activeTab === "expenses" ? 1 : activeTab === "revenues" ? 2 : 3,
          clientCode: client_code,
          invoiceId: invoiceHistoryId.current,
          token,
          offset: invoiceHistoryOffset,
          limit: invoiceHistoryLimit,
        };
        dispatchGetInvoiceHistoryAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceHistoryOffset]);

  useEffect(() => {
    if (invoiceHistoryData?.length) {
      setInvoiceAuditData((prev: any) => [...prev, ...invoiceHistoryData]);
    }
  }, [invoiceHistoryData]);

  useEffect(() => {
    if (othersHistoryData?.length) {
      setInvoiceOthersData((prev: any) => [...prev, ...othersHistoryData]);
    }
  }, [othersHistoryData]);

  const handleAddInvoice = (type: string | undefined, template: string) => {
    if (type === "manufacturing") {
      if (template?.length) {
        history.push({
          pathname: `/invoice-generation/add-manufacturing/${client_code}?type=${type}`,
          state: { client_code, company_name, template },
        });
      } else {
        history.push({
          pathname: `/invoice-generation/add-manufacturing/${client_code}?type=${type}`,
          state: { client_code, company_name },
        });
      }
    } else if (type === "others") {
      history.push({
        pathname: `/invoice-generation/add-others/${client_code}?type=${type}`,
        state: { client_code, company_name },
      });
    } else {
      history.push({
        pathname: `/invoice-generation/add/${client_code}?type=${type}`,
        state: { client_code, company_name },
      });
    }
  };


  const handleBomAddpage = (name: string) => {
    if (name === "Select from Template") {
      handleAddInvoice("manufacturing", "showBOMTemplate");
    } else {
      handleAddInvoice("manufacturing", "");
    }
  };



  const handleAddSales =(type:string) =>{
    if(type==="ocr"){
      handleAddInvoice("revenues", "ocr");
    }else{
      handleAddInvoice("revenues", "");
    }
  }

  const handleTabChange = (tabs: string | undefined) => {
    setActiveTab(tabs);

    const { location = {} } = history;

    delete history?.location?.state?.expenseAttachement;
    delete history?.location?.state?.expenseApproval;
    delete history?.location?.state?.revenueAttachement;
    delete history?.location?.state?.revenueApproval;
    delete history?.location?.state?.expenseComment;
    delete history?.location?.state?.revenueComment;
    delete history?.location?.state?.expensestartDate;
    delete history?.location?.state?.revenuestartDate;
    delete history?.location?.state?.expenseendDate;
    delete history?.location?.state?.revenueendDate;
    delete history?.location?.state?.expenseInvoiceStartDate;
    delete history?.location?.state?.revenueInvoiceStartDate;
    delete history?.location?.state?.expenseInvoiceEndDate;
    delete history?.location?.state?.revenueInvoiceEndDate;
    delete history?.location?.state?.radioValue;
    delete history?.location?.state?.revenueRadioValue;
    delete history?.location?.state?.otherComment;
    delete history?.location?.state?.otherStartDate;
    delete history?.location?.state?.otherEndDate;
    delete history?.location?.state?.otherInvoiceStartDate;
    delete history?.location?.state?.otherInvoiceEndDate;
    delete history?.location?.state?.otherRadioValue;
    delete history?.location?.state?.otherAttachement;
    delete history?.location?.state?.otherApproval;

    history.push({
      ...location,
      search: "",
      hash: `#${tabs}`,
      pathname: `/invoice-generation/${client_code}`,
    });
  };

  const renderTabs = () => {
    let finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  const handleToggleInvoiceCommentsModal = () => {
    setShowInvoiceCommentsModal(!showInvoiceCommentsModal);
    setInvoiceData(null);
  };

  const handleToggleInvoiceSendInvoiceEmailModal = () => {
    setShowSendInvoiceEmailModal(!showSendInvoiceEmailModal);
  };

  const handleSetInvoiceData = (data: any) => {
    setInvoiceData(data);
    let finalData: GetCommentPayloadType = {
      type: activeTab,
      token,
      invoice_id: data?.id ? data?.id : data?.others_id,
      client_code,
    };
    dispatchGetAllInvoiceCommentsAction(finalData);
  };

  const getInvoiceIdPdf = (id: number | null) => {
    setPdfInvoiceId(id);
  };

  const handleSubmitInvoiceComment = (data: any) => {
    let finalData: AddCommentPayloadType = {
      client_code,
      token,
      type: activeTab,
      invoice_id: data?.invoice_id,
      comments: data?.commentText,
    };
    dispatchPostAllInvoiceCommentsAction(finalData);
  };

  const handleSubmitLockEntry = (date: string) => {
    let finalData: LockEntryPayloadType = {
      client_code,
      token,
      type: activeTab,
      date,
    };
    dispatchPostLockEntryAction(finalData);
  };
  const handleSubmitBomLockEntry= (date:string)=>{
    let finalData: LockEntryBomPayloadType = {
      client_code,
      token,
      date,
    };
    dispatchPostLockEntryBomAction(finalData);

  }

  const handleSendInvoiceEmailData = ({
    ledgerId,
    invoiceId,
    fileAttachment,
  }: SendInvoiceEmailData) => {
    dispatchResetSingleCustomerSupplier();
    setFileAttachment(fileAttachment);
    setInvoiceId(invoiceId);
    if (client_code) {
      const finalData = {
        token,
        client_code,
        customerSupplierId: ledgerId,
      };
      dispatchGetSingleCustomerSupplierAction(finalData);
    }
  };

  const handleSendOverdueEmail = (attachment: string) => {
    setShowSendInvoiceEmailModal(!showSendInvoiceEmailModal);
    if (token && sendInvoiceEmailInput && invoiceId) {
      const finalData = {
        token,
        clientCode: client_code,
        attachment,
        invoiceId,
        type: activeTab,
        emailId: sendInvoiceEmailInput,
      };
      dispatchSendOverdueEmailApiAction(finalData);
    }
  };

  const toggleInvoiceHistory = (type: string, id?: number) => {
    dispatchResetInvoiceHistoryAction();
    dispatchResetOtherHistoryData();
    dispatchResetOtherHistoryCount();
    setInvoiceAuditData([]);
    setInvoiceOthersData([]);
    setIsInvoiceHistory((prev: any) => !prev);
    if (type === "open") {
      setInvoiceHistoryOffset(0);

      if (id) {
        if (activeTab === "others") {
          invoiceHistoryId.current = id;
          let finalData = {
            clientCode: client_code,
            invoiceId: id,
            token,
            offset: 0,
            limit: invoiceHistoryLimit,
          };
          dispatchGetOthersInvoiceHistoryAction(finalData);
        } else {
          invoiceHistoryId.current = id;
          let finalData = {
            invoiceType:
              activeTab === "expenses" ? 1 : activeTab === "revenues" ? 2 : 3,
            clientCode: client_code,
            invoiceId: id,
            token,
            offset: 0,
            limit: invoiceHistoryLimit,
          };
          dispatchGetInvoiceHistoryAction(finalData);
        }
      }
    }
  };

  const handleLoadMore = () => {
    setInvoiceHistoryOffset(invoiceHistoryOffset + invoiceHistoryLimit);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetInvoicingError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type={
              !!error &&
              error.includes(
                "Columns are not assigned to you. Please contact administrator!"
              )
                ? "warning"
                : "error"
            }
            isOpen={!!error}
            title={
              !!error &&
              error.includes(
                "Columns are not assigned to you. Please contact administrator!"
              )
                ? "Info"
                : "Error"
            }
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoicingError();
              dispatchResetMessageAndSuccess();
            }}
          />
        );
      }
    }
    if (commentsSuccess === 1) {
      dispatchResetCommentsSuccess();
      toast.success("Comment Added Successfully!", {
        duration: 2000,
      });

      if ((invoiceData?.id || invoiceData?.others_id) && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type: activeTab,
          token,
          invoice_id: invoiceData?.id
            ? invoiceData?.id
            : invoiceData?.others_id,
          client_code,
        };
        dispatchGetAllInvoiceCommentsAction(finalData);
      }
    } else if (
      overDueEmailSuccess === 0 &&
      error?.includes("Time difference should be more than 24 hours")
    ) {
      toast.error(
        "Please wait at least 24-hours before sending email to the Customer!",
        {
          duration: 3000,
        }
      );
      dispatchResetInvoiceGenerationOverDueEmailSuccess();
      dispatchResetInvoiceGenerationOverDueEmailMessage();
    } else if (
      overDueEmailSuccess === 1 &&
      overDueEmailMessage?.includes(
        "Invoice payment mail has been sent successfully."
      )
    ) {
      toast.success("Invoice payment mail has been sent successfully!", {
        duration: 2000,
      });
      dispatchResetInvoiceGenerationOverDueEmailSuccess();
      dispatchResetInvoiceGenerationOverDueEmailMessage();
    }
  
    if (
      success === 1 &&
      message &&
      message === "invoice deleted successfully!"
    ) {
      dispatchResetSuccess();
      toast.success("Invoice deleted successfully!", {
        duration: 2000,
      });
    }
    if (
      success === 1 &&
      message &&
      message === "others invoice deleted successfully!"
    ) {
      dispatchResetSuccess();
      toast.success("Others Invoice deleted successfully!", {
        duration: 2000,
      });
    }
    return false;
  };

  let component;

  if (activeTab === "others") {
    component = (
      <AllOtherInvoicesList
        client_code={client_code}
        isAddOthersPresent={isAddOthersPresent}
        history={history}
        company_name={company_name}
        isEditOthersPresent={isEditOthersPresent}
        isDownloadOtherReportPresent={isDownloadOtherReportPresent}
        isBulkUploadOtherPresent={isBulkUploadOtherPresent}
        handleToggleInvoiceCommentsModal={handleToggleInvoiceCommentsModal}
        handleSetInvoiceData={handleSetInvoiceData}
        isViewOthersInvoicePresent={isViewOthersInvoicePresent}
        isOthersListCommentPresent={isOthersListCommentPresent}
        showInvoiceCommentsModal={showInvoiceCommentsModal}
        currencySign={currencySign}
        handleSubmitLockEntry={handleSubmitLockEntry}
        invoiceHistoryData={invoiceOthersData}
        invoiceHistoryOffset={invoiceHistoryOffset}
        isOthersHistory={isOthersHistory}
        handleLoadMore={handleLoadMore}
        invoiceHistoryCount={othersHistoryCount}
        invoiceHistoryLimit={invoiceHistoryLimit}
        toggleInvoiceHistory={toggleInvoiceHistory}
        isInvoiceHistory={isInvoiceHistory}
      />
    );
  }
  if (activeTab === "expenses") {
    component = (
      <ExpenseInvoicesList
        client_code={client_code}
        history={history}
        toggleInvoiceHistory={toggleInvoiceHistory}
        isInvoiceHistory={isInvoiceHistory}
        invoiceHistoryData={invoiceAuditData}
        isExpenseHistory={isExpenseHistory}
        company_name={company_name}
        handleLoadMore={handleLoadMore}
        invoiceHistoryOffset={invoiceHistoryOffset}
        isAddExpensePresent={isAddExpensePresent}
        isEditExpensePresent={isEditExpensePresent}
        isViewExpensesInvoicePresent={isViewExpensesInvoicePresent}
        isDownloadExpenseReportPresent={isDownloadExpenseReportPresent}
        isExpenseListCommentPresent={isExpenseListCommentPresent}
        handleToggleInvoiceCommentsModal={handleToggleInvoiceCommentsModal}
        handleSetInvoiceData={handleSetInvoiceData}
        currencySign={currencySign}
        showInvoiceCommentsModal={showInvoiceCommentsModal}
        handleSubmitLockEntry={handleSubmitLockEntry}
        setShowSendInvoiceEmailModal={setShowSendInvoiceEmailModal}
        handleSendInvoiceEmailData={handleSendInvoiceEmailData}
        invoiceHistoryLimit={invoiceHistoryLimit}
        isBulkUploadExpensePresent={isBulkUploadExpensePresent}
        getInvoiceIdPdf={getInvoiceIdPdf}
        isExpenseInvoiceDownloadPresent={isExpenseInvoiceDownloadPresent}
      />
    );
  }

  if (activeTab === "revenues") {
    component = (
      <RevenueInvoicesList
        isEinvoice={isEinvoice}
        client_code={client_code}
        history={history}
        toggleInvoiceHistory={toggleInvoiceHistory}
        isInvoiceHistory={isInvoiceHistory}
        isRevenueHistory={isRevenueHistory}
        invoiceHistoryData={invoiceAuditData}
        company_name={company_name}
        handleLoadMore={handleLoadMore}
        invoiceHistoryOffset={invoiceHistoryOffset}
        isAddSalesPresent={isAddSalesPresent}
        isEditSalesPresent={isEditSalesPresent}
        isDownloadSalesPresent={isDownloadSalesPresent}
        isDownloadSalesReportPresent={isDownloadSalesReportPresent}
        isRevenueListCommentPresent={isRevenueListCommentPresent}
        handleToggleInvoiceCommentsModal={handleToggleInvoiceCommentsModal}
        handleSetInvoiceData={handleSetInvoiceData}
        isViewSalesInvoicePresent={isViewSalesInvoicePresent}
        currencySign={currencySign}
        getInvoiceIdPdf={getInvoiceIdPdf}
        showInvoiceCommentsModal={showInvoiceCommentsModal}
        handleSubmitLockEntry={handleSubmitLockEntry}
        setShowSendInvoiceEmailModal={setShowSendInvoiceEmailModal}
        handleSendInvoiceEmailData={handleSendInvoiceEmailData}
        invoiceHistoryLimit={invoiceHistoryLimit}
        isBulkUploadSalesPresent={isBulkUploadSalesPresent}
      />
    );
  }

  if (activeTab === "manufacturing") {
    component = (
      <BomInvoicesList
        client_code={client_code}
        history={history}
        company_name={company_name}
        isAddManufacturingPresent={isAddManufacturingPresent}
        isEditManufacturingPresent={isEditManufacturingPresent}
        handleSubmitBomLockEntry={handleSubmitBomLockEntry}
      />
    );
  }

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader title="All Invoices" />
        <div className="d-flex align-items-center">
          {client_code ? (
            <>
              <UserIcon /> &nbsp;
              {!!company_name ? company_name : companyName}{" "}
              {"(" + client_code + ")"}
            </>
          ) : null}
        </div>
      </div>
      <div className="col-md-12">
        <WeeklyApprovedUsersInvoiceEntriesCountCard type="invoice" />
      </div>
      <div className="col-md-12 pb-2">
        <div className="new-table-card">
          <div
            style={{
              background: "#d8dee4",
              borderRadius: "5px 5px 0 0",
              padding: "0px 15px 0px 15px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{ justifyContent: "space-between" }}
            >
              <div className="d-flex">{renderTabs()}</div>

              <div className="">
                <div className="d-flex flex-row justify-content-end">          
                
                {isAddExpensePresent && (
                    <button
                      className="btn btn-primary mr-3"
                      style={{ fontSize: "13px" }}
                      onClick={() => {
                        handleAddInvoice("expenses", "");
                      }}
                    >
                      <img src={AddIconWhite} alt="add_icon" />
                      {/* <AddIcon /> */}
                      Expense
                    </button>
                  )}
                  {isAddSalesPresent && (
                    <button
                      style={{ fontSize: "13px" }}
                      className="btn btn-secondary mr-3"
                      onClick={() => {
                        handleAddInvoice("revenues", "");
                      }}
                    >
                      <img src={AddIconWhite} alt="add_icon" />
                      {/* <AddIcon /> */}
                      Sales
                    </button>
                  )}
                  {isAddOthersPresent && (
                    <button
                      className="btn btn-outline-secondary mr-3"
                      onClick={() => {
                        handleAddInvoice("others", "");
                      }}
                      style={{
                        color: "#dd4433",
                        border: "1px solid #dd4433",
                        fontSize: "13px",
                      }}
                    >
                      <img src={AddIconColor} alt="" />
                      Other
                    </button>
                  )}
                  {isAddManufacturingPresent && (
                    <BOMAddModal handleBomAddpage={handleBomAddpage} />
                  )}

                 
                </div>
              </div>
            </div>
          </div>
          <div className="pt-3">{component}</div>
        </div>
      </div>
      {handleErrorModal()}
      <Toaster />
      {showInvoiceCommentsModal && (
        <InvoiceCommentsModal
          modal={showInvoiceCommentsModal}
          toggleModal={handleToggleInvoiceCommentsModal}
          data={invoiceData}
          commentList={allComments}
          handlePostComment={handleSubmitInvoiceComment}
        />
      )}

      {activeTab === "revenues" && showSendInvoiceEmailModal && (
        <SendInvoiceEmailModal
          modal={showSendInvoiceEmailModal}
          toggleModal={handleToggleInvoiceSendInvoiceEmailModal}
          data={sendInvoiceEmailInput}
          setSendInvoiceEmailInput={setSendInvoiceEmailInput}
          handlePostComment={handleSubmitInvoiceComment}
          handleSendOverdueEmail={handleSendOverdueEmail}
          fileAttachment={fileAttachment}
          currencySign={currencySign}
          customerSingleInvoiceData={customerSingleInvoiceData}
          clientCode={client_code}
          pdfInvoiceId={pdfInvoiceId}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  userData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  error: state.invoiceGeneration.error,
  invoiceError: state.invoiceGeneration.error,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  mappedExpensesColumnsList: state.invoiceGeneration.mappedExpensesColumnsList,
  mappedRevenueColumnsList: state.invoiceGeneration.mappedRevenueColumnsList,
  mappedOthersColumnList: state.invoiceGeneration.mappedOthersColumnList,
  invoiceGeneration: state.invoiceGeneration,
  allOtherInvoicesList: state.invoiceGeneration.allOtherInvoicesList,
  allComments: state.invoiceGeneration.allComments,
  commentsSuccess: state.invoiceGeneration.commentsSuccess,
  expensesInvoicesTotal: state.invoiceGeneration.expensesInvoicesTotal,
  revenueInvoicesTotal: state.invoiceGeneration.revenueInvoicesTotal,
  otherInvoicesTotal: state.invoiceGeneration.otherInvoicesTotal,
  message: state.invoiceGeneration.message,
  currencySign: state.auth.currencySign,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  overDueEmailSuccess: state.invoiceGeneration.overDueEmailSuccess,
  overDueEmailMessage: state.invoiceGeneration.overDueEmailMessage,
  companyName: state.auth.companyName,
  customerSingleInvoiceData: state.invoiceGeneration.customerSingleInvoiceData,
  invoiceHistoryData: state.invoiceGeneration.invoiceHistoryData,
  othersHistoryData: state.invoiceGeneration.othersHistoryData,
  othersHistoryCount: state.invoiceGeneration.othersHistoryCount,
  invoiceHistoryCount: state.invoiceGeneration.invoiceHistoryCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetClientColumnListAction: (
    data: GetAllMappedClientColumnsPayloadType
  ) => dispatch(getAllMappedClientColumnListAction(data)),
  dispatchResetInvoicingError: () => dispatch(resetInvoiceGenerationError()),
  dispatchResetInvoicingSuccess: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchGetAllColumnsAction: (token: string) =>
    dispatch(getAllInvoiceColumnsListAction(token)),
  dispatchAssignColumnsToClientAction: (
    data: AssignInvoiceColumnsToClientPayloadType
  ) => dispatch(assignInvoiceColumnsToClientAction(data)),
  dispatchResetMappedExpensesColumnsListAction: () =>
    dispatch(resetMappedExpensesColumnList()),
  dispatchResetInvoiceGenerationSuccess: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetInvoiceGenerationError: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchGetAllBusinessAddressAction: (data: any) =>
    dispatch(getAllBusinessAddressAction(data)),
  dispatchGetAllOtherInvoicesList: (data: GetAllOtherInvoicesListPayloadType) =>
    dispatch(getAllOtherInvoicesListAction(data)),
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) =>
    dispatch(getInvoiceAllComment(data)),
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) =>
    dispatch(postInvoiceAllComment(data)),
  dispatchPostLockEntryAction: (data: LockEntryPayloadType) =>
    dispatch(postLockingEntryAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchSendOverdueEmailApiAction: (data: SendOverdueEmailPayloadType) =>
    dispatch(sendOverdueEmailApiAction(data)),
  dispatchResetCommentsSuccess: () => dispatch(resetcommentsSuccess()),
  ///all invoive reset Total count
  dispatchResetExpenseInvoicesTotal: () =>
    dispatch(resetExpenseInvoicesTotal()),
  dispatchResetRevenueInvoicesTotal: () =>
    dispatch(resetRevenueInvoicesTotal()),
  dispatchResetOtherInvoicesTotal: () => dispatch(resetOtherInvoicesTotal()),
  dispatchResetSuccess: () => dispatch(resetInvoicingSuccess()),
  dispatchResetMessageAndSuccess: () => dispatch(resetSuccess()),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
  dispatchResetInvoiceGenerationOverDueEmailSuccess: () =>
    dispatch(resetInvoiceGenerationOverDueEmailSuccess()),
  dispatchResetInvoiceGenerationOverDueEmailMessage: () =>
    dispatch(resetInvoiceGenerationOverDueEmailMessage()),
  dispatchResetInvoiceHistoryAction: () => dispatch(resetInvoiceHistoryData()),
  dispatchGetInvoiceHistoryAction: (data: InvoiceHistoryPayloadType) =>
    dispatch(getInvoiceHistoryDataAction(data)),
  dispatchGetOthersInvoiceHistoryAction: (data: InvoiceHistoryPayloadType) =>
    dispatch(getOthersInvoiceHistoryDataAction(data)),
  dispatchResetOtherHistoryData: () => dispatch(resetOthersHistoryData()),
  dispatchResetOtherHistoryCount: () => dispatch(resetOthersHistoryCount()),
  dispatchResetCurrencyExchangeDetails: () =>
    dispatch(resetCurrencyExchangeDetails()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetSingleInvoiceDetails: () =>
    dispatch(resetSingleInvoiceDetails()),
  dispatchPostLockEntryBomAction: (data: LockEntryBomPayloadType) =>
    dispatch(postLockingEntryBOMAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceGenerationList);
